module.exports = __webpack_public_path__ + "static/ProServices-Photo2-0a0bddd21d9e77be34c7be4a8660cf08.png";